import React from 'react';
import { Table } from '../common';
import { Button, TextLink } from '../common';
import serviceNow from '../../services/serviceNow.config';
import PortOpeningRequest from '../../models/entities/PortOpeningRequest';
import { WorkflowState } from '../../models/enums/WorkflowState';
import { useNavigate } from 'react-router-dom';
import ProgressBarSmall from './components/ProgressBarSmall';

interface PortOpeningRequestsByPORRowProps {
	request: PortOpeningRequest;
	subOwnerDisplayName?: string;
}

const PortOpeningRequestsByPORRow = ({ request, subOwnerDisplayName }: PortOpeningRequestsByPORRowProps) => {
	const navigate = useNavigate();
	const getTicketURL = (ticket: string) => {
		return ticket.toUpperCase().includes('CRQ')
			? `https://itconsole.na.xom.com/#/${ticket}`
			: `https://${serviceNow.serviceNowEnv}.service-now.com/nav_to.do?uri=change_request.do?sysparm_query=number=${ticket}&sysparm_limit=1`;
	};

	const linkToTicket = () => {
		const implementationTicket = request.implementationTicket();
		return implementationTicket !== '' ? (
			<TextLink external href={getTicketURL(implementationTicket)} target="_blank">
				{implementationTicket}&nbsp;
			</TextLink>
		) : (
			'-'
		);
	};

	const handleViewDetails = () => {
		navigate(`/subscriptions/${request.subscriptionRequestId}/portOpeningRequests/${request.id}`);
	};

	return (
		<Table.Row key={request.id}>
			<Table.Cell>{request.id}</Table.Cell>
			<Table.Cell>{request.direction.displayName}</Table.Cell>
			<Table.Cell style={{ position: 'relative' }}>
				<ProgressBarSmall
					workflowState={request.workflowInstance.currentWorkflowInstanceState.workflowState}
					porScope={request.direction.name}
				/>
			</Table.Cell>
			<Table.Cell>{linkToTicket()}</Table.Cell>
			<Table.Cell>{request.isAttestation ? 'Yes' : 'No'}</Table.Cell>
			<Table.Cell>{request.workflowInstance.createdBy.displayName}</Table.Cell>
			<Table.Cell>{request.contactUser?.displayName}</Table.Cell>
			<Table.Cell>
				{request.workflowInstance.currentWorkflowInstanceState.workflowState ===
				WorkflowState.PendingSubscriptionOwnerApproval
					? subOwnerDisplayName
					: request.approvingUser?.displayName}
			</Table.Cell>
			<Table.Cell>
				<Button name="See Details" onClick={handleViewDetails} variant="primary" size="small" />
			</Table.Cell>
		</Table.Row>
	);
};

export default PortOpeningRequestsByPORRow;
